export const LEGAL_DOCS_UK = {
  privacy: {
    title: "Політика конфіденційності",
    path: "/privacy-policy",
    sections: [
      {
        heading: "1. Вступ",
        paragraphs: [
          "VCK Business Lab (\"VCK\", \"ми\", \"нас\") — компанія віртуальної бізнес-підтримки з офісом в Едмонтоні, Альберта, Канада, що обслуговує клієнтів у Канаді та за кордоном. Ця Політика конфіденційності пояснює, як ми збираємо, використовуємо, розкриваємо, зберігаємо та захищаємо персональну інформацію під час роботи вебсайту та надання наших послуг.",
          "Ця політика структурована відповідно до принципів Закону Альберти про захист персональної інформації (PIPA). Якщо ви перебуваєте за межами Альберти, можуть також застосовуватися обов'язкові закони про приватність вашої юрисдикції, і ніщо в цій політиці не має на меті виключити права, які законно не можуть бути відхилені.",
        ],
      },
      {
        heading: "2. Яку персональну інформацію ми можемо збирати",
        bullets: [
          "Контактна інформація — ім'я, адреса електронної пошти, номер телефону, назва компанії, країна та бажаний спосіб зв'язку.",
          "Інформація про запити та розрахунки вартості — деталі, якими ви ділитеся в контактних формах, запитах на розрахунок, бронюваннях консультацій та листуванні, включно з типом потрібної підтримки.",
          "Інформація про клієнтів і проєкти — документи, інструкції, деталі проєктів та інші матеріали, які ви надаєте для виконання послуг.",
          "Платіжна інформація — номери рахунків, суми платежів та записи про транзакції. Номери карток обробляються нашим платіжним провайдером (Stripe) і ніколи не зберігаються на наших серверах.",
          "Інформація про використання вебсайту та технічна інформація — переглянуті сторінки, тип браузера, пристрій, приблизне місцезнаходження та сторінки, з яких ви перейшли.",
        ],
      },
      {
        heading: "3. Файли cookie та аналітика",
        paragraphs: [
          "Наш вебсайт використовує невелику кількість файлів cookie — наприклад, щоб запам'ятати вашу мовну перевагу, — а також може використовувати дбайливу до приватності аналітику, щоб зрозуміти, як використовується сайт. Деталі та способи керування cookie через налаштування браузера описані в нашій Політиці cookies.",
        ],
      },
      {
        heading: "4. Чому ми збираємо інформацію",
        bullets: [
          "Щоб відповідати на запити та готувати розрахунки вартості.",
          "Щоб планувати та надавати консультації й послуги.",
          "Щоб керувати відносинами з клієнтами, проєктами, виставленням рахунків і платежами.",
          "Щоб надсилати сервісні повідомлення, наприклад підтвердження бронювання та нагадування про зустрічі.",
          "Щоб покращувати наш вебсайт, послуги та клієнтський досвід.",
          "Щоб виконувати юридичні, бухгалтерські та облікові зобов'язання.",
        ],
      },
      {
        heading: "5. Згода",
        paragraphs: [
          "Надсилаючи запит, бронюючи консультацію або замовляючи наші послуги, ви погоджуєтеся на збирання, використання та розкриття вашої персональної інформації, як описано в цій політиці. Ви можете в будь-який момент відкликати згоду, зв'язавшись з нами, з урахуванням юридичних та договірних обмежень; відкликання згоди може обмежити нашу можливість надавати вам послуги.",
        ],
      },
      {
        heading: "6. Використання та розкриття",
        paragraphs: [
          "Ми використовуємо персональну інформацію лише для описаних вище цілей або для сумісних з ними цілей. Ми не продаємо персональну інформацію. Ми розкриваємо персональну інформацію лише за потреби для надання послуг, як описано в цій політиці, або якщо це вимагається чи дозволяється законом.",
        ],
      },
      {
        heading: "7. Постачальники послуг та субпідрядники",
        paragraphs: [
          "Ми можемо працювати з довіреними постачальниками послуг і субпідрядниками (наприклад, перекладачами, адміністративними спеціалістами або технічними помічниками), які допомагають у виконанні вашого проєкту. Вони отримують доступ лише до інформації, необхідної для їхньої роботи, і зобов'язані захищати її відповідно до зобов'язань про конфіденційність.",
        ],
      },
      {
        heading: "8. Хмарні та програмні провайдери",
        paragraphs: [
          "Ми використовуємо надійних хмарних та програмних провайдерів для електронної пошти, планування, зберігання файлів, управління проєктами, обробки платежів та хостингу вебсайту. Ваша інформація може оброблятися цими сторонніми технологічними провайдерами від нашого імені відповідно до їхніх власних практик безпеки та приватності.",
        ],
      },
      {
        heading: "9. Міжнародна обробка даних",
        paragraphs: [
          "Оскільки ми працюємо віртуально та обслуговуємо клієнтів у всьому світі, ваша інформація може оброблятися сторонніми технологічними провайдерами та зберігатися за межами вашої провінції або країни, зокрема в Сполучених Штатах чи інших юрисдикціях, якщо це дозволено законом. Інформація, що зберігається в іншій юрисдикції, може підпадати під закони цієї юрисдикції.",
        ],
      },
      {
        heading: "10. Інформаційна безпека",
        paragraphs: [
          "Ми застосовуємо розумні адміністративні, технічні та фізичні заходи захисту, що відповідають чутливості інформації, — зокрема контроль доступу, захищені платформи та практики конфіденційності. Проте жоден спосіб передачі або зберігання не є абсолютно безпечним, і ми не можемо гарантувати абсолютну безпеку даних.",
        ],
      },
      {
        heading: "11. Конфіденційна інформація клієнтів",
        paragraphs: [
          "Матеріали клієнтів, ділова інформація та деталі проєктів вважаються конфіденційними, використовуються лише для надання ваших послуг і передаються лише особам та провайдерам, залученим до вашого замовлення, або якщо це вимагається законом.",
        ],
      },
      {
        heading: "12. Зберігання та безпечне видалення",
        paragraphs: [
          "Ми зберігаємо персональну інформацію лише стільки часу, скільки це потрібно для цілей, задля яких вона збиралася, а також для виконання юридичних, бухгалтерських або договірних вимог. Коли інформація більше не потрібна, вона безпечно видаляється або знищується.",
        ],
      },
      {
        heading: "13. Запити на доступ та виправлення",
        paragraphs: [
          "Ви можете запросити доступ до вашої персональної інформації або попросити її виправити, зв'язавшись з нами за адресою нижче. Ми відповімо протягом розумного строку та відповідно до чинного законодавства.",
        ],
      },
      {
        heading: "14. Скарги щодо приватності",
        paragraphs: [
          "Якщо у вас є занепокоєння щодо нашого поводження з персональною інформацією, спершу зв'яжіться з нами, щоб ми могли спробувати вирішити питання. Якщо ви не задоволені, ви можете звернутися до Офісу Комісара з інформації та приватності Альберти.",
        ],
      },
      {
        heading: "15. Інциденти безпеки та витоки даних",
        paragraphs: [
          "Якщо інцидент безпеки створює реальний ризик значної шкоди, ми повідомимо про це постраждалих осіб і відповідного регулятора, як це вимагається чинним законодавством, і вживемо розумних заходів для зменшення ризику шкоди.",
        ],
      },
      {
        heading: "16. Спеціаліст із захисту даних",
        paragraphs: [
          "Спеціаліст із захисту даних відповідає за питання приватності, запити на доступ і виправлення, скарги та реагування на інциденти приватності. Зі спеціалістом із захисту даних можна зв'язатися за адресою:",
          "Спеціаліст із захисту даних, VCK Business Lab, Едмонтон, Альберта, Канада — office@vckbusinesslab.com",
        ],
      },
      {
        heading: "17. Маркетингові комунікації (CASL)",
        paragraphs: [
          "VCK Business Lab може надсилати комерційні електронні повідомлення лише в межах, дозволених чинним законодавством, зокрема Канадським законом про боротьбу зі спамом (CASL). Де це вимагається, VCK отримує згоду перед надсиланням промоційних повідомлень.",
          "Комерційні повідомлення від VCK ідентифікують VCK Business Lab, містять дійсну контактну інформацію та працюючий механізм відписки. Ви можете в будь-який момент відкликати згоду на отримання маркетингових повідомлень, і запити на відписку обробляються негайно та в строк, встановлений законом.",
          "Після запиту на відписку ми можемо зберігати обмежену інформацію для придушення, щоб гарантувати, що ви випадково не будете знову додані до маркетингових списків.",
        ],
      },
      {
        heading: "18. Зміни до цієї політики",
        paragraphs: [
          "Ми можемо час від часу оновлювати цю Політику конфіденційності. Поточна версія завжди буде розміщена на цій сторінці з датою «Останнє оновлення».",
        ],
      },
      {
        heading: "19. Контакт з питань приватності",
        paragraphs: [
          "Питання щодо приватності, запити на доступ чи виправлення та скарги можна надсилати на office@vckbusinesslab.com. VCK Business Lab знаходиться в Едмонтоні, Альберта, Канада.",
        ],
      },
    ],
  },
  terms: {
    title: "Умови використання вебсайту",
    path: "/terms-of-use",
    sections: [
      {
        heading: "1. Прийняття цих умов",
        paragraphs: [
          "Отримуючи доступ до вебсайту VCK Business Lab або використовуючи його, ви приймаєте ці Умови використання вебсайту. Якщо ви не погоджуєтеся, будь ласка, не використовуйте вебсайт.",
        ],
      },
      {
        heading: "2. Інформаційна мета",
        paragraphs: [
          "Цей вебсайт надається з загальною інформаційною метою про VCK Business Lab та її послуги. Вміст вебсайту не є офертою, а замовлення послуг оформлюється лише через письмовий розрахунок вартості, угоду про надання послуг, технічне завдання або підтвердження бронювання.",
        ],
      },
      {
        heading: "3. Жодних професійних консультацій",
        paragraphs: [
          "Ніщо на цьому вебсайті не є професійною консультацією будь-якого роду — зокрема юридичною, бухгалтерською, податковою, імміграційною, медичною чи інженерною. VCK Business Lab не надає професійні інженерні послуги, юридичні консультації, бухгалтерські чи податкові консультації, імміграційні чи медичні консультації, і вміст вебсайту не слід розцінювати як такий.",
        ],
      },
      {
        heading: "4. Відсутність клієнтських відносин",
        paragraphs: [
          "Використання цього вебсайту, надсилання запиту, бронювання консультації або отримання відповіді не створює клієнтських відносин. Клієнтські відносини починаються лише тоді, коли письмовий розрахунок вартості, угода про надання послуг, технічне завдання або підтвердження бронювання прийняті обома сторонами.",
        ],
      },
      {
        heading: "5. Інтелектуальна власність",
        paragraphs: [
          "Вміст цього вебсайту — зокрема текст, дизайн, графіка, логотипи та макет — належить VCK Business Lab або використовується за ліцензією та захищений чинними законами про інтелектуальну власність. Ви можете переглядати вебсайт і ділитися посиланнями на нього, але не можете копіювати, відтворювати або публікувати його вміст у комерційних цілях без письмового дозволу.",
        ],
      },
      {
        heading: "6. Дозволене та заборонене використання",
        paragraphs: [
          "Ви можете використовувати цей вебсайт лише в законних цілях. Ви погоджуєтеся не зловживати вебсайтом, не намагатися отримати несанкціонований доступ до будь-якої його частини чи систем, не збирати інформацію масово, не подавати неправдиву чи оманливу інформацію, не заважати роботі вебсайту та не використовувати його способом, що порушує чинне законодавство.",
        ],
      },
      {
        heading: "7. Точність інформації",
        paragraphs: [
          "Ми працюємо над тим, щоб інформація на вебсайті була точною та актуальною, але не гарантуємо, що весь вміст завжди є повним, точним чи актуальним. Описи послуг, доступність і ціни можуть змінюватися.",
        ],
      },
      {
        heading: "8. Ціни",
        paragraphs: [
          "Ціни, зазначені на цьому вебсайті, є початковими або орієнтовними, якщо вони не підтверджені в письмовому розрахунку вартості або угоді для вашого конкретного проєкту. Остаточна ціна залежить від обсягу, складності, обсягу робіт, терміновості та умов, узгоджених письмово.",
        ],
      },
      {
        heading: "9. Сторонні посилання та сервіси",
        paragraphs: [
          "Цей вебсайт посилається на сторонні сервіси або інтегрується з ними, наприклад планування (Cal.com), обробка платежів (Stripe) та обмін повідомленнями (WhatsApp). Ми не контролюємо сторонні вебсайти та сервіси і не несемо відповідальності за їхній вміст чи практики приватності.",
        ],
      },
      {
        heading: "10. Доступність та перерви",
        paragraphs: [
          "Ми прагнемо забезпечувати доступність вебсайту, але він може бути час від часу перерваний або недоступний — через технічне обслуговування, оновлення, технічні проблеми або причини поза нашим контролем — без попередження.",
        ],
      },
      {
        heading: "11. Обмеження відповідальності",
        paragraphs: [
          "У максимальній мірі, дозволеній чинним законодавством, VCK Business Lab не несе відповідальності за будь-які непрямі, випадкові, побічні або спеціальні збитки, що виникають внаслідок використання або неможливості використання цього вебсайту чи його вмісту. Ніщо в цих умовах не виключає та не обмежує відповідальність, яка законно не може бути виключена чи обмежена.",
        ],
      },
      {
        heading: "12. Відшкодування",
        paragraphs: [
          "У межах, дозволених законом, ви погоджуєтеся відшкодувати VCK Business Lab збитки та захистити її від претензій, втрат або витрат, що виникають внаслідок вашого неправильного використання цього вебсайту або порушення цих умов.",
        ],
      },
      {
        heading: "13. Зміни до вебсайту чи цих умов",
        paragraphs: [
          "Ми можемо час від часу оновлювати вебсайт і ці умови. Поточна версія буде розміщена на цій сторінці з датою «Останнє оновлення», і подальше використання вебсайту означає вашу згоду з оновленими умовами.",
        ],
      },
      {
        heading: "14. Чинне право",
        paragraphs: [
          "Ці умови регулюються законами провінції Альберта та чинними федеральними законами Канади. Якщо ви отримуєте доступ до цього вебсайту з іншої юрисдикції, можуть також застосовуватися обов'язкові місцеві закони цієї юрисдикції, і ніщо в цих умовах не має на меті скасувати права, які законно не можуть бути відхилені.",
        ],
      },
    ],
  },
  service: {
    title: "Умови надання послуг та загальне застереження",
    path: "/service-terms",
    sections: [
      {
        heading: "1. Як починається співпраця",
        paragraphs: [
          "Усі послуги VCK Business Lab вимагають прийняття розрахунку вартості, угоди про надання послуг, технічного завдання, підтвердження бронювання або іншої письмової угоди до початку роботи. Ніщо на цьому вебсайті — зокрема описи послуг і зазначені ціни — саме по собі не створює замовлення.",
        ],
      },
      {
        heading: "2. Обсяг, терміни та вартість",
        paragraphs: [
          "Усі послуги надаються за наявності. Обсяг, результати, терміни, кількість правок і вартість залежать від конкретного проєкту та визначаються в письмовому розрахунку вартості або угоді для цього замовлення. Умови підписаної угоди мають перевагу над загальною інформацією на вебсайті.",
        ],
      },
      {
        heading: "3. Інформація та матеріали клієнта",
        paragraphs: [
          "Клієнт відповідає за надання повної, точної та своєчасної інформації, інструкцій і матеріалів. VCK може покладатися на інформацію та матеріали, надані клієнтом, і не несе відповідальності за помилки в кінцевій роботі, що виникли через неточну або неповну надану клієнтом інформацію.",
        ],
      },
      {
        heading: "4. Затримки з боку клієнта",
        paragraphs: [
          "Терміни передбачають своєчасну комунікацію та погодження з боку клієнта. Затримки з боку клієнта — наприклад, пізній зворотний зв'язок, відсутність матеріалів або відкладені погодження — можуть відповідно впливати на терміни та дати здачі.",
        ],
      },
      {
        heading: "5. Відсутність гарантованих результатів",
        paragraphs: [
          "VCK Business Lab не гарантує конкретних бізнес-результатів, зокрема продажів, доходу, прибутку, позицій у пошукових системах, трафіку вебсайту, залучення клієнтів, регуляторного прийняття документів чи інших результатів. Ми зобов'язуємося працювати професійно та сумлінно, а не гарантувати конкретні результати, які залежать від багатьох факторів поза нашим контролем.",
        ],
      },
      {
        heading: "6. Виправлення",
        paragraphs: [
          "Якщо VCK допустить істотну помилку в послузі, будь ласка, негайно повідомте нас. Згідно з чинним законодавством, VCK має отримати розумну можливість виправити або повторно виконати відповідну роботу до того, як вдаватимуться інші засоби захисту.",
        ],
      },
      {
        heading: "7. Сторонні сервіси",
        paragraphs: [
          "Стороннє програмне забезпечення, хостинг-провайдери, реєстратори доменів, плагіни, платіжні платформи, інструменти планування та подібні сервіси перебувають поза безпосереднім контролем VCK. Ми не несемо відповідальності за збої, зміни, втрату даних, зміну цін або припинення роботи сторонніх сервісів, хоча докладемо розумних зусиль, щоб допомогти вам адаптуватися.",
        ],
      },
      {
        heading: "8. Перевірка та погодження",
        paragraphs: [
          "Клієнт відповідає за перевірку та затвердження фінального контенту, документів, перекладів і вебматеріалів перед публікацією або використанням. Після погодження або публікації клієнтом відповідальність за використання фінального матеріалу несе клієнт.",
        ],
      },
      {
        heading: "9. Відношення до підписаних угод",
        paragraphs: [
          "Ці Умови надання послуг доповнюють — і не замінюють — будь-яку Мастер-угоду про надання послуг, підписаний розрахунок вартості, графік послуг або Технічне завдання між вами та VCK Business Lab. У разі суперечності діє підписана угода.",
        ],
      },
    ],
  },
  translation: {
    title: "Застереження щодо перекладацьких послуг",
    path: "/translation-disclaimer",
    sections: [
      {
        heading: "1. Загальні та ділові мовні послуги",
        paragraphs: [
          "Стандартні публічно рекламовані мовні послуги VCK Business Lab — це загальний та діловий письмовий і усний переклад для повсякденної ділової комунікації, нарад, документів, взаємодії з клієнтами, вебсайтів, презентацій та подібних нерегульованих цілей.",
        ],
      },
      {
        heading: "2. Ваша відповідальність пояснити призначення",
        paragraphs: [
          "Ви відповідаєте за те, щоб повідомити нам про призначення перекладу та будь-які вимоги організації-отримувача до початку роботи, щоб ми могли підтвердити, чи входить робота до нашої компетенції.",
        ],
      },
      {
        heading: "3. Не сертифікований, якщо прямо не зазначено",
        paragraphs: [
          "Загальні переклади не слід автоматично вважати сертифікованими, присяжними, юридичними або офіційно прийнятними документами. VCK Business Lab не представляє свої стандартні послуги письмового та усного перекладу як сертифіковані, присяжні, судово-сертифіковані, юридичні або офіційно акредитовані, якщо це прямо не зазначено для конкретного проєкту та не виконується відповідно кваліфікованим фахівцем.",
        ],
      },
      {
        heading: "4. Відсутність гарантії прийняття",
        paragraphs: [
          "Ми не гарантуємо, що будь-який переклад буде прийнятий судами, державними органами, імміграційними службами, навчальними закладами, банками чи іншими третіми сторонами, якщо конкретна вимога щодо кваліфікації не була підтверджена заздалегідь і робота не була організована відповідно до неї.",
        ],
      },
      {
        heading: "5. Фактори якості усного перекладу",
        paragraphs: [
          "На якість усного перекладу можуть впливати фактори поза нашим контролем, зокрема якість звуку та з'єднання, спеціалізована термінологія, неповна вихідна інформація, переривання та темп чи чіткість мовлення учасників. Надання матеріалів, глосаріїв і контексту заздалегідь допомагає нам забезпечити найкращий можливий результат.",
        ],
      },
      {
        heading: "6. Не заміна професійної консультації",
        paragraphs: [
          "Загальний діловий усний і письмовий переклад не замінює юридичну, медичну чи іншу регульовану професійну консультацію. Судовий, юридичний, медичний або інший регульований чи спеціалізований переклад надається лише за попередньою домовленістю та якщо виконавець відповідає чинним вимогам.",
        ],
      },
    ],
  },
  website: {
    title: "Застереження щодо вебпослуг",
    path: "/website-disclaimer",
    sections: [
      {
        heading: "1. Власність на контент та дозволи",
        paragraphs: [
          "Клієнт відповідає за володіння або наявність дозволу на використання всього контенту, наданого для вебпроєкту, — зокрема текстів, зображень, логотипів, відео, шрифтів і торговельних марок. VCK може покладатися на підтвердження клієнта, що надані матеріали належним чином ліцензовані.",
        ],
      },
      {
        heading: "2. Домени та хостинг",
        paragraphs: [
          "Якщо проєктна угода не передбачає інше, доменні імена та хостинг-акаунти реєструються на ім'я клієнта і залишаються відповідальністю клієнта, включно з продовженням. Ми можемо координувати налаштування та продовження в межах узгодженого обсягу, але застосовуються умови сторонніх реєстраторів і хостинг-провайдерів.",
        ],
      },
      {
        heading: "3. Стороннє програмне забезпечення, плагіни та застосунки",
        paragraphs: [
          "Вебсайти часто покладаються на сторонні платформи, теми, плагіни та застосунки. Вони поза безпосереднім контролем VCK: вони можуть змінюватися, оновлюватися, припинятися, мати вразливості або з часом ставати несумісними.",
        ],
      },
      {
        heading: "4. Електронна комерція та платіжні провайдери",
        paragraphs: [
          "Онлайн-платежі обробляються сторонніми провайдерами (наприклад, Stripe). Застосовуються умови, комісії, практики безпеки та доступність цих провайдерів, і VCK не несе відповідальності за їхні збої, рішення чи дії щодо акаунтів.",
        ],
      },
      {
        heading: "5. Обмеження безпеки",
        paragraphs: [
          "Ми дотримуємося розумних практик безпеки під час створення та обслуговування вебсайтів, але жоден вебсайт не може бути абсолютно безпечним, безперебійним чи безпомилковим. Безпека — це спільна, постійна відповідальність, що включає збереження клієнтом своїх акаунтів і облікових даних у безпеці.",
        ],
      },
      {
        heading: "6. Резервні копії",
        paragraphs: [
          "Умови резервного копіювання залежать від платформи та узгодженого обсягу. Якщо постійне обслуговування з резервним копіюванням не входить до вашої угоди, клієнт відповідає за власне резервне копіювання.",
        ],
      },
      {
        heading: "7. Зміни сумісності",
        paragraphs: [
          "Браузери, пристрої та платформи розвиваються. Вебсайт, який працює сьогодні, у майбутньому може потребувати оновлень для збереження сумісності; такі оновлення виходять за межі початкової розробки, якщо вони не покриті планом обслуговування.",
        ],
      },
      {
        heading: "8. Позиції в пошукових системах",
        paragraphs: [
          "Ми створюємо вебсайти з дотриманням належних технічних та контентних практик, але не гарантуємо позиції в пошукових системах, швидкість індексації, рівень трафіку чи місце за будь-яким ключовим словом.",
        ],
      },
      {
        heading: "9. Доступність та юридична відповідність",
        paragraphs: [
          "Де це застосовно, клієнт відповідає за повідомлення нам про конкретні вимоги щодо доступності, приватності або регуляторної відповідності для свого вебсайту (наприклад, законодавство про доступність або галузеві правила), щоб їх можна було врахувати в узгодженому обсязі. Якщо це прямо не включено в угоду, формальні аудити доступності та юридичні перевірки відповідності не входять до розробки вебсайту.",
        ],
      },
      {
        heading: "10. Погодження клієнтом перед запуском",
        paragraphs: [
          "Вебсайти запускаються лише після перевірки та погодження клієнтом. Після погодження та запуску відповідальність за опублікований контент несе клієнт.",
        ],
      },
      {
        heading: "11. Постійне обслуговування",
        paragraphs: [
          "Оновлення, моніторинг та обслуговування після запуску надаються лише якщо вони включені в письмову угоду або місячний план підтримки.",
        ],
      },
    ],
  },
  refund: {
    title: "Політика оплати, скасування та повернення",
    path: "/refund-policy",
    sections: [
      {
        heading: "1. Структура оплати",
        bullets: [
          "Невеликі проєкти можуть вимагати повної оплати до початку роботи.",
          "Більші проєкти можуть вимагати депозиту з етапними та фінальними платежами, як зазначено в розрахунку вартості або угоді.",
          "Місячні плани підтримки оплачуються наперед за кожен розрахунковий період.",
          "Оплата здійснюється через безпечне платіжне посилання, яке VCK Business Lab надсилає вам безпосередньо після підтвердження послуги, обсягу та вартості — цей вебсайт не пропонує публічної сторінки оплати.",
          "Пріоритетна, термінова або екстрена робота може вимагати передоплати.",
        ],
      },
      {
        heading: "2. Депозити",
        paragraphs: [
          "Депозити резервують час і ресурси для вашого проєкту. У межах, дозволених законом, депозит може стати неповоротним після початку роботи.",
        ],
      },
      {
        heading: "3. Виконана робота та витрачений час",
        paragraphs: [
          "Завершена робота та вже витрачений час, як правило, не підлягають поверненню, оскільки їх неможливо повернути.",
        ],
      },
      {
        heading: "4. Якщо ми допустимо істотну помилку",
        paragraphs: [
          "Якщо VCK допустить істотну помилку в наданій роботі, будь ласка, негайно повідомте нас. Згідно з чинним законодавством, VCK спершу має отримати розумну можливість виправити або повторно виконати відповідну роботу до того, як розглядатимуться повернення чи інші засоби захисту.",
        ],
      },
      {
        heading: "5. Скасування",
        paragraphs: [
          "Умови скасування можуть відрізнятися залежно від послуги та вашої підписаної угоди. Для місячних планів підтримки скасування набуває чинності відповідно до вашої угоди — зазвичай наприкінці поточного попередньо оплаченого розрахункового періоду, — а суми, вже виставлені за поточний період, не повертаються, якщо це не вимагається законом або не зазначено у вашій угоді.",
        ],
      },
      {
        heading: "6. Витрати на третіх осіб",
        paragraphs: [
          "Витрати на третіх осіб та вже понесені від вашого імені витрати (наприклад, домени, ліцензії на програмне забезпечення, стокові матеріали або вже виконана субпідрядна робота), як правило, не підлягають поверненню.",
        ],
      },
      {
        heading: "7. Ваші обов'язкові права",
        paragraphs: [
          "Ніщо в цій політиці не скасовує та не обмежує будь-які обов'язкові споживчі права, які ви маєте за чинним законодавством. Якщо ці закони надають вам додаткові права, вони продовжують застосовуватися.",
        ],
      },
    ],
  },
  cookies: {
    title: "Політика cookies",
    path: "/cookie-policy",
    sections: [
      {
        heading: "1. Що таке cookies",
        paragraphs: [
          "Cookies — це невеликі текстові файли, що зберігаються на вашому пристрої під час відвідування вебсайту. Вони допомагають вебсайтам працювати, запам'ятовувати переваги та розуміти, як використовується сайт.",
        ],
      },
      {
        heading: "2. Cookies, які ми використовуємо",
        bullets: [
          "Необхідні cookies — потрібні для роботи вебсайту (наприклад, cookies безпеки та балансування навантаження від нашої хостинг-платформи).",
          "Функціональні cookies — запам'ятовують ваш вибір, наприклад бажану мову вебсайту.",
          "Аналітичні cookies — можуть використовуватися для узагальненого розуміння того, як відвідувачі користуються сайтом, щоб ми могли його покращувати.",
          "Сторонні інтеграції — деякі вбудовані або пов'язані сервіси (наприклад, інструменти планування, оплати або обміну повідомленнями) можуть встановлювати власні cookies під час вашої взаємодії з ними відповідно до їхніх політик приватності.",
        ],
      },
      {
        heading: "3. Як керувати cookies",
        paragraphs: [
          "Ви можете керувати або видаляти cookies через налаштування браузера в будь-який момент, і більшість браузерів дозволяє повністю блокувати cookies або попереджати перед збереженням cookie. Якщо сайт надає інструмент налаштування cookies, ви також можете керувати необхідними cookies там. Блокування деяких cookies може вплинути на роботу частин вебсайту.",
        ],
      },
      {
        heading: "4. Зміни до цієї політики",
        paragraphs: [
          "Ми можемо оновлювати цю Політику cookies у міру розвитку вебсайту. Поточна версія завжди буде розміщена на цій сторінці з датою «Останнє оновлення».",
        ],
      },
    ],
  },
  accessibility: {
    title: "Заява про доступність",
    path: "/accessibility",
    sections: [
      {
        heading: "1. Наше зобов'язання",
        paragraphs: [
          "VCK Business Lab прагне зробити свій вебсайт зручним і доступним для якомога більшої кількості людей, зокрема тих, хто використовує допоміжні технології. Ми розглядаємо доступність як постійний процес, а не разовий проєкт.",
        ],
      },
      {
        heading: "2. Ваш відгук важливий",
        paragraphs: [
          "Якщо у вас виникли труднощі з використанням будь-якої частини цього вебсайту або у вас є пропозиції, які зроблять його доступнішим для вас, будь ласка, зв'яжіться з нами за адресою office@vckbusinesslab.com. Ми розглянемо ваш відгук і спробуємо внести розумні покращення.",
        ],
      },
      {
        heading: "3. Добросовісне зусилля",
        paragraphs: [
          "Ця заява відображає наше добросовісне зобов'язання щодо доступності. Ми не заявляємо про формальну сертифікацію WCAG або повну відповідність будь-якому конкретному стандарту, і ми вдячні за можливість вдосконалюватися.",
        ],
      },
    ],
  },
  newcomer: {
    title: "Дисклеймер підтримки новоприбулих",
    path: "/newcomer-disclaimer",
    sections: [
      {
        heading: "1. Обсяг послуг підтримки новоприбулих",
        paragraphs: [
          "VCK Business Lab надає загальні адміністративні, мовні, перекладацькі, координаційні та практичні послуги підтримки.",
        ],
      },
      {
        heading: "2. Жодних імміграційних чи громадянських порад",
        paragraphs: [
          "VCK Business Lab не надає імміграційних порад або порад щодо громадянства і не здійснює представництва, а також не діє як імміграційний консультант чи імміграційний адвокат.",
          "Ми не консультуємо клієнтів щодо імміграційної відповідності, імміграційних програм, візових чи дозвільних стратегій, заяв на постійне проживання, заяв на громадянство або того, як слід заповнювати імміграційні заяви.",
        ],
      },
      {
        heading: "3. Жодних інших регульованих професійних порад",
        paragraphs: [
          "Ми також не надаємо юридичних, податкових, фінансових, медичних, освітніх, трудових чи інших регульованих професійних порад.",
        ],
      },
      {
        heading: "4. Направлення до ліцензованих фахівців",
        paragraphs: [
          "Якщо клієнту потрібні регульовані професійні послуги, VCK Business Lab може порекомендувати звернутися до відповідного ліцензованого фахівця.",
          "Адміністративна та мовна допомога, що надається VCK Business Lab, не повинна тлумачитися як професійна порада або представництво.",
        ],
      },
      {
        heading: "5. Контакти",
        paragraphs: [
          "VCK Business Lab — Едмонтон, Альберта, Канада",
          "Email: office@vckbusinesslab.com • Телефон: +1 587 385 6058 • Вебсайт: vckbusinesslab.com",
        ],
      },
    ],
  },
};

export const LEGAL_LINKS_UK = [
  { key: "privacy", label: "Політика конфіденційності" },
  { key: "terms", label: "Умови використання" },
  { key: "service", label: "Умови надання послуг" },
  { key: "translation", label: "Застереження щодо перекладу" },
  { key: "website", label: "Застереження щодо вебпослуг" },
  { key: "refund", label: "Оплата та повернення" },
  { key: "cookies", label: "Політика cookies" },
  { key: "accessibility", label: "Доступність" },
  { key: "newcomer", label: "Дисклеймер підтримки новоприбулих" },
];
